import moment from 'moment';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { AssignmentDisplayData } from 'types/assignment';
import { selectors } from 'utils/reduxSelector';
import { DetailsSingleDatum } from './detailsSingleDatum';

type Props = Pick<AssignmentDisplayData, 'forward'>;

export const ForwardDetails: FC<Props> = ({ forward: { dataInoltro, emailDa } }) => {
  const loggedEmail = useSelector(selectors.authSelector.userEmail);
  const providerEmail = useSelector(selectors.assignmentSelector.getProviderEmail);

  return loggedEmail === providerEmail ? (
    <DetailsSingleDatum value={`${emailDa} • ${moment(dataInoltro).format('DD/MM/YYYY HH:mm')}`} title="Inoltrato da" />
  ) : null;
};

export const MobileForwardDetails: FC<Props> = ({ forward: { dataInoltro, emailDa } }) => (
  <>
    <DetailsSingleDatum title="Inoltrato da" value={emailDa} />
    <DetailsSingleDatum
      title="Data Inoltro"
      value={dataInoltro ? moment(dataInoltro).format('DD/MM/YYYY HH:mm') : ''}
    />
  </>
);
